function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _excluded = ["className", "onClick", "placeholder", "value"],
  _excluded2 = ["name", "component", "format", "onClick", "valueGetter"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import { get, identity, isNil, noop, filterInvalidDOMProps } from '../../utils';
import { Types } from '../helpers';
var propTypes = {
  columns: PropTypes.arrayOf(Types.column).isRequired,
  rowComponent: Types.component,
  rowData: PropTypes.any,
  ascending: PropTypes.bool,
  sortPath: PropTypes.string,
  sortFunc: PropTypes.func,
  valueGetter: PropTypes.func
};
var DefaultRowComponent = function DefaultRowComponent(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("tr", null, children);
}; // eslint-disable-line
var DefaultCellComponent = function DefaultCellComponent(_ref2 // eslint-disable-line
) {
  var className = _ref2.className,
    onClick = _ref2.onClick,
    placeholder = _ref2.placeholder,
    value = _ref2.value,
    rest = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement("td", _objectSpread({
    className: className,
    onClick: onClick
  }, filterInvalidDOMProps(rest)), isNil(value) ? placeholder : value);
};
function TableRow(_ref3) {
  var columns = _ref3.columns,
    _ref3$rowComponent = _ref3.rowComponent,
    RowComponent = _ref3$rowComponent === void 0 ? DefaultRowComponent : _ref3$rowComponent,
    rowData = _ref3.rowData,
    ascending = _ref3.ascending,
    sortPath = _ref3.sortPath,
    sortFunc = _ref3.sortFunc,
    valueGetter = _ref3.valueGetter;
  return /*#__PURE__*/React.createElement(RowComponent, {
    data: rowData,
    ascending: ascending,
    sortPath: sortPath,
    sortFunc: sortFunc,
    valueGetter: valueGetter
  }, columns.map(function (column, key) {
    var name = column.name,
      _column$component = column.component,
      CellComponent = _column$component === void 0 ? DefaultCellComponent : _column$component,
      _column$format = column.format,
      format = _column$format === void 0 ? identity : _column$format,
      _column$onClick = column.onClick,
      onClick = _column$onClick === void 0 ? noop : _column$onClick,
      valueGetter = column.valueGetter,
      rest = _objectWithoutProperties(column, _excluded2);
    var cellValue = valueGetter ? valueGetter(rowData) : get(name, rowData);
    var formattedValue = format(cellValue);
    var onColClick = column.disabled ? noop : function () {
      return onClick(rowData);
    };
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/jsx-key
      React.createElement(CellComponent, _objectSpread({
        key: key,
        value: formattedValue,
        name: name,
        data: rowData,
        onClick: onColClick
      }, rest))
    );
  }));
}
TableRow.propTypes = propTypes;
export default TableRow;